<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Manage Holidays</h6>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <modal
        :show.sync="modals.showModal"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-md"
      >
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
        >
          <template>
            <form role="form" class="mb--4">
              <div class="form-group row mb--2">
                <label class="col-md-4 col-form-label form-control-label"
                  >Date</label
                >
                <div class="col-md-8">
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker slot-scope="{focus, blur}"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{allowInput: true}"
                              class="form-control datepicker"
                              v-model="dates.simple">
                    </flat-picker>
                  </base-input>
                </div>
              </div>

              
              <div class="form-group row mb--2">
                <label class="col-md-4 col-form-label form-control-label"
                  >Title</label
                >
                <div class="col-md-8">
                  <base-input
                    placeholder="Title"
                    v-model="myObj.title"
                    v-bind:error="titleError"
                  ></base-input>
                </div>
              </div>
              
              <div class="form-group row mb--2">
                <label class="col-md-4 col-form-label form-control-label"
                  >Message</label
                >
                <div class="col-md-8">
                  <textarea class="form-control" 
                  id="holidayMessage" rows="4" 
                  placeholder="Write a large text here ..."
                    v-bind:error="messageError"></textarea>
                </div>
              </div>

              <div style="margin-top: 30px">
                <base-button
                  :disabled="saving"
                  @click="AddNewHoliday()"
                  type="primary"
                  class="col"
                >
                  <i v-bind:class="sign"></i> {{ optionName }}</base-button
                >
              </div>
            </form>
          </template>
        </card>
      </modal>

      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header"> </template>

          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                hidden
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary pull-right"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-button
                  :disabled="saving"
                  @click="ShowModal()"
                  type="primary"
                  class="col"
                >
                  <i v-bind:class="sign"></i> Add Holiday</base-button
                >

                <!-- <base-input
                  v-model="searchQuery"
                  disabled
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                >
                </base-input> -->
              </div>
            </div>

            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
              style="margin-top: 20px"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column min-width="180px" align="right" label="Options">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click="editRecord($index, row)"
                    class="like btn-link"
                    type="primary"
                    size="sm"
                    icon
                  >
                    <i class="text-white far fa-edit"></i>
                  </base-button>

                  <base-button
                    @click.native="deleteRecoard($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white fas fa-times"></i>
                  </base-button>

                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import users from "../Tables/users2";
import axios from "axios";
import qs from "qs";
import Vue from "vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  mixins: [clientPaginationMixin],
  components: {
    Multiselect,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker,
  },
  created() {
    this.LoadData();
    this.LoadCollectionDropdown();
  },
  mounted() {},
  data() {
    return {
      selects: {
              categories: [{value: 'Mobile', value: 'Mobile'},
              {value: 'Laptop', label: 'Laptop'},
              {value: 'Ear Phones', label: 'Ear Phones'}],
          },
          dates: {
            simple: "2021-04-08"
          },
      myObj: {
        sr_id: 0,
        name: "",
        cost: "",
        time: "",
      },
      propsToSearch: ["name", "category", "cost", "time",],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 220,
          sortable: true,
        },{
          prop: "category",
          label: "Category",
          minWidth: 220,
          sortable: true,
        },
        {
          prop: "csot",
          label: "Cost",
          minWidth: 220,
          sortable: true,
        },
        {
          prop: "time",
          label: "Time",
          minWidth: 120,
          sortable: true,
        },
      ],
      file: "",
      tableData: [],
      collectionData: [],
      collectionOptions: [],
      selectedTags: [],
      selectedRows: [],
      modals: {
        showModal: false,
      },
      optionName: "Add Holiday",
      saving: false,
      name: "",
      prefixname: "",
      prefixError: false,
      nameError: false,
      titleError: false,
      messageError: false,
      sign: "",
      err: {
        nameerr: false,
        contacterr: false,
        mobileerr: false,
        purposevsterr: false,
        dateerr: false,
      },
      currentDate: moment().format("YYYY-MM-DD"),
      eIndex: 0,
    };
  },

  methods: {

    ShowModal() {
      this.collectionData = [];
      this.modals.showModal = true;
      this.optionName = "Add Holiday";
      this.myObj.sr = 0;
      this.myObj.title = "";
      this.holidayMessage = "";
      this.titleError = false;
      this.messageError = false;
    },
    selectFile() {
      this.file = this.$refs.file.files[0];
    },
    date: function (date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
    AddNewHoliday() {
      if (this.myObj.title === "") {
        this.titleError = "Please enter title";
      } else {
        this.titleError = false;
      }

      if (this.holidayMessage === "") {
        this.messageError = "Please enter message";
      } else {
        this.messageError = false;
      }
    },
    GetError() {
      return this.nameError;
      return this.prefixError;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
